import { render, staticRenderFns } from "./sectionWiseScreen.vue?vue&type=template&id=60e9ba54&scoped=true&"
import script from "./sectionWiseScreen.vue?vue&type=script&lang=js&"
export * from "./sectionWiseScreen.vue?vue&type=script&lang=js&"
import style0 from "./sectionWiseScreen.vue?vue&type=style&index=0&id=60e9ba54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e9ba54",
  null
  
)

export default component.exports